import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IPagingOptions } from '@/coreDomainsModule/paging';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IInventoryRepository } from '@/coreInfrastructureModule/interfaces/IInventoryRepository';
import { DetailAlertData } from '../pages/useInventoryDashboardStore/types';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { FilterService } from '@/coreDomainsModule/services/filterService';
import { DashboardAdapter } from '../adapters/DashboardAdapter';
import { DashboardAlertSettingInSeverity } from '../domains/entities/DashboardAlert';

/**
 * 在庫削減ダッシュボードの概要情報を取得する
 */
export class GetInventoryDashboardDetailAggBizWithAlertUseCase {
  private repository: IInventoryRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IInventoryRepository) {
    this.repository = repository;
  }

  /**
   * 在庫削減ダッシュボードの詳細情報取得
   * @param severity - 重大度
   * @param direction - アラート向き
   * @param sortType - ソートタイプ
   * @param sortTarget - ソート対象
   * @param limit - 表示制限
   * @param offset - オフセット
   * @param filterItemInfo - フィルター情報
   * @param alertFilterInfo - アラートのフィルタ情報
   * @param alertSettings - アラートの設定
   * @returns - 在庫削減ダッシュボードの概要情報
   */
  public async execute(
    severity: 'critical' | 'warning',
    direction: 'excess' | 'shortage',
    sortType?: string,
    sortTarget?: string,
    limit?: number,
    offset?: number,
    filterItemInfo?: FilterContentItem[],
    alertFilterInfo?: string[],
    alertSettings?: DashboardAlertSettingInSeverity
  ): Promise<INetworkResult<[DetailAlertData, IPagingOptions], IError>> {
    const filterItem = filterItemInfo ? FilterService.convertFilterObject(filterItemInfo) : undefined;
    const alertFilterItem = alertFilterInfo?.map((a) => encodeURIComponent(a)).join(',');
    const networkResult = await this.repository.getInventoryAnalyticsDetailsAggregateBusinessWithAlert(
      severity,
      direction,
      sortType,
      sortTarget,
      limit,
      offset,
      filterItem,
      alertFilterItem,
      alertSettings
    );

    switch (networkResult.status.type) {
      case 'success': {
        const result = networkResult.status.data;
        return {
          status: {
            type: 'success',
            data: [DashboardAdapter.adaptDetailAlertData(result.businessData, result.numberData), result.pagingOptions],
          },
        };
      }
      case 'error':
        return { status: { type: 'error', error: networkResult.status.error } };
    }
  }
}
